/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';
import { ExternalLinkIcon } from '@coursera/cds-icons';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import { getPortfolioProjectPublishSuccessDialogTranslations } from 'bundles/portfolio-projects/constants';
import EVENTS from 'bundles/portfolio-projects/events';

export type Props = {
  open: boolean;
  canViewProject: boolean;
  onClose: () => void;
};

const styles = {
  buttonGroup: css`
    display: flex;
    gap: var(--cds-spacing-200);
  `,
};

const PortfolioProjectPublishSuccessDialog = ({ open, onClose, canViewProject = false }: Props) => {
  const { Actions, Content, HeadingGroup } = Dialog;
  const {
    PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_TITLE,
    PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_DESCRIPTION,
    PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_CONFIRM_LABEL,
    PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_VIEW_PROJECT_LABEL,
  } = getPortfolioProjectPublishSuccessDialogTranslations();

  return (
    <Dialog open={open} onClose={onClose}>
      <HeadingGroup title={PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_TITLE}>
        {PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_TITLE}
      </HeadingGroup>

      <Content>
        <Typography2 component="p" color="supportText">
          {PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_DESCRIPTION}
        </Typography2>
      </Content>

      <Actions css={styles.buttonGroup}>
        <Button variant="primary" onClick={onClose}>
          {PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_CONFIRM_LABEL}
        </Button>

        {canViewProject && (
          <Button
            target="_blank"
            variant="secondary"
            href="/account-profile"
            rel="noopener noreferrer"
            icon={<ExternalLinkIcon />}
            onClick={onClose}
            component={TrackedLink2}
            linkType="a"
            withVisibilityTracking
            requireFullyVisible
            trackingName={EVENTS.portfolioBuilderPublishViewProject}
          >
            {PORTFOLIO_PROJECT_PUBLISH_SUCCESS_DIALOG_VIEW_PROJECT_LABEL}
          </Button>
        )}
      </Actions>
    </Dialog>
  );
};

export default PortfolioProjectPublishSuccessDialog;
